import React, { useEffect, useState, useRef } from 'react';
import { message } from '../Message';
import axios from 'axios';
import Spinner from '../Spinner';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CompareImage from '../CompareImage';

const modes = {
  pro: 'Pro',
  basic: 'Basic',
};

const APP_URL = process.env.REACT_APP_APP_URL;
const API_BASE = APP_URL?.endsWith('/api') ? APP_URL : `${APP_URL}/api`;
const REOK = process.env.REACT_APP_REOK;

const ApproveRenewPhotos = ({ t, isCreating, firebase, onFetchUser, userData}) => {
  const scrollableRef = useRef(null);

  const [jobsList, setJobsList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [showShopFurniture, setShowShopFurniture] = useState(false);
  const [imageShop, setImageShop] = useState(null);
  const [searching, setSearching] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lastJobCreatedAt, setLastJobCreatedAt] = useState("");
  const [isSpinning, setIsSpinning] = useState(false);

  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("");
  const [email, setEmail] = useState("");
  const [removeId, setRemoveId] = useState("");
  const [openCompare, setOpenCompare] = useState(false);
  const [compareImages, setCompareImages] = useState({});

  const columns = [
    { id: 'action', label: 'Actions', minWidth: 40 },
    { id: 'reason', label: 'Reasons', minWidth: 30 },
    { id: 'view', label: 'View', minWidth: 30 },
    { id: 'email', label: 'Email', minWidth: 50 },
    { id: 'createdAt', label: 'Date', minWidth: 100 },
  ];

  useEffect(() => {

    firebase.getRenewPhotos()
    .then((result) => {
      const jobsArray = result.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

      const updatedData = jobsArray.map((item) => {
        const date = new Date(item.createdAt);
        const gmtOffset = 7; // GMT+7
        date.setHours(date.getHours() + gmtOffset);
        const formattedDate = `${date.toISOString().substr(11, 8)} ${date.toISOString().substr(8, 2)}-${date.toISOString().substr(5, 2)}-${date.toISOString().substr(0, 4)}`;
        
        return {
          ...item,
          createdAt: formattedDate,
          action: (
            <>
              <Button
                style={{marginRight: "2px", marginBottom: "2px"}}
                variant="outlined"
                color="success"
                onClick={() => handleApprove(item.id)} // Assuming `row.id` is the unique identifier for your data
              >
                Approve
              </Button>
              <Button
                style={{marginRight: "2px", marginBottom: "2px"}}
                variant="outlined"
                color="error"
                onClick={() => handleDelete(item.id)} // Assuming `row.id` is the unique identifier for your data
              >
                Cancel
              </Button>
            </>
          ),
          view: (
            <>
              <img src={item.upscaleUrl} style={{width: "30px", cursor: "pointer"}} onClick={(e) => onOpenCompare(e, item)}></img>
            </>
          )
        };
      });

      setRows(updatedData);
    })
    .catch((error) => {
      console.log(error);
    });

    return () => {
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    setMode("");
  };

  const handleOk = async () => {
    setIsSpinning(true);

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${firebase.auth.currentUser.accessToken}`,
    };

    const requestDataEng = {
      id: removeId,
      reok: REOK,
    };

    if (mode === "approve") {
      try {
        const result = await axios.post(`${API_BASE}/approve-renew`, requestDataEng, { headers });
        message.success(result.data);
        const updatedData = rows.filter(item => item.id !== removeId);
        setRows(updatedData);
      } catch (error) {
        message.error(error.response?.data?.error || error.response?.data || error.message);
      }
    }

    if (mode === "disapprove") {
      try {
        const result = await axios.post(`${API_BASE}/disapprove-renew`, requestDataEng, { headers });
        message.success(result.data);
        const updatedData = rows.filter(item => item.id !== removeId);
        setRows(updatedData);
      } catch (error) {
        message.error(error.response?.data?.error || error.response?.data || error.message);
      }
    }

    handleClose();
    setIsSpinning(false);
  };

  function convertStatus(status) {
    switch (status) {
      case false:
        return "Waiting"
        break;
      case true:
        return "Done"
        break;
      
      default:
        return ""
        break;
    }
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function generateRandomFileName(extension) {
    const randomNumber = Math.floor(Math.random() * 1000000000); // Generate a random number between 0 and 999999999
    return `noithatai-${randomNumber}.${extension}`;
  }

  const onFindAgency = (image) => {
    setOpenForm(true);
    setImageShop(image);
    setShowShopFurniture(false);
  }

  const onCloseShopFurniture = () => {
    setShowShopFurniture(false);
  }

  const handleDelete = async (id) => {
    setOpen(true);
    setMode("disapprove");
    setRemoveId(id);
  }

  const handleApprove = async (id) => {
    setOpen(true);
    setMode("approve");
    setRemoveId(id);
  }

  const onOpenCompare = (e, item) => {
    console.log(item);
    e.preventDefault();
    setCompareImages({
      before: item.originalUrl,
      after: item.upscaleUrl
    });
    setOpenCompare(true);
  }

  const onCloseCompare = () => {
    setOpenCompare(false);
  }

  return (
    <>
      <div className="my-design" ref={scrollableRef}>
      <h3>Approve Renew Photos</h3>
        <p style={{ color: '#8c8c8c', fontSize: '14px', marginTop: "0", marginBottom: "1rem"}}>
          {"Only admin can do."}
        </p>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                    {columns.map((column) => {
                      const value = row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </TableCell>
                              
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
        {/* <h3 style={{ marginTop: "20px" }}>Chọn thiết kế bạn muốn thi công</h3>
        <p style={{ color: '#8c8c8c', fontSize: '14px', marginTop: "0", marginBottom: "1rem"}}>
          Nội thất AI sẽ kết nối bạn tới các đơn vị gần bạn uy tín và chất lượng chuyên về thi công nội thất, xây dựng và vật tư.
        </p>
        <div className="rnftg-h-full rnftg-w-full">
          <div className="rnftg-h-full dark:rnftg-bg-gray-900">
            <div className="rnftg-flex rnftg-flex-col pd-2">
              <div className="rnftg-grid rnftg-gap-6 rnftg-grid-flow-row rnftg-grid-cols-1 md:rnftg-grid-cols-2 lg:rnftg-grid-cols-3 xl:rnftg-grid-cols-3">
              {jobsList.length > 0 &&
                jobsList.map((job, key) => (
                  <ImageAgency key={key} job={job} onFindAgency={onFindAgency}/>
                ))}
              </div>
            </div>
          </div>
        </div> */}
      </div>
      <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Attention please ⚠⚠⚠</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {mode === "approve" && (
              <>
                Your are excuting <span style={{color: "green"}}>{mode}</span> to <span style={{color: "green"}}>{email}</span>
              </>
            )}
            {mode === "disapprove" && (
              <>
                Your are excuting <span style={{color: "red"}}>{mode}</span> to <span style={{color: "red"}}>{email}</span>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleOk} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
      {/* { showShopFurniture && <ShopFurniture productsList={productsList} firebase={firebase} t={t} image={imageShop} onClose={onCloseShopFurniture}></ShopFurniture>}
      { searching && <Searching title="Searching products"/> }
      { openForm && <AgencyForm userData={userData} productsList={productsList} firebase={firebase} t={t} image={imageShop} onClose={onCloseAgencyForm}></AgencyForm>}
      {isSpinning && <Spinner />} */}
      {openCompare && <CompareImage onClose={onCloseCompare} images={compareImages}/>}
      {isSpinning && <Spinner />}
    </>
  );
};

export default ApproveRenewPhotos;
